const messages = {
  fi: {
    common: {
      yes: 'Kyllä',
      no: 'Ei',
      title: 'Oletko uusi asiakas, rekisteröidy tästä!',
      continue: 'Jatka eteenpäin',
      company: 'Yritys',
      person: 'Henkilö',
      bill: 'Lasku',
      save: 'Tallenna',
      cancel: 'Peruuta',
      close: 'Sulje',
      finland: 'Suomi'
    },
    companyType: {
      0: '',
      1: 'Osakeyhtiö',
      2: 'Kommandiittiyhtiö',
      3: 'Avoin yhtiö',
      4: 'Yksityinen elinkeinoharjoittaja',
      5: 'Säätiö',
      6: 'Yhdistys',
      7: 'Julkisyhtiö',
      8: 'Osuuskunta',
      9: 'Sivuliike',
      10: 'Muu'
    },
    claimType: {
      5: 'Palvelu',
      7: 'Kuljetus',
      8: 'Irtaimen kauppa',
      14: 'Muu',
      2: 'Vuokra'
    },
    typicalClaim: {
      1: 'Kulutusluotto',
      2: 'Huoneenvuokra',
      3: 'Osamaksukauppa',
      4: 'Postimyynti / internet kauppa',
      5: 'Palvelusopimus',
      6: 'Velkakirja',
      7: 'Kuljetussopimus',
      8: 'Irtaimen kauppa',
      9: 'Luontaistuotteet',
      10: 'Kuntosalisaatava',
      11: 'Sähkösaatava',
      12: 'Valvontamaksu',
      13: 'Vakuutus',
      14: 'Muu Peruste',
      15: 'Pienlaina',
      16: 'Lehti/Ilmoitus/Kustannus',
      17: 'Vesi - ja viemärisaatavat',
      18: 'Muu vuokra',
      19: 'Vertaislaina'
    },
    languages: {
      1: 'Suomi',
      2: 'Ruotsi',
      3: 'Englanti',
      4: 'Saksa',
      6: 'Viro',
      7: 'Venäjä',
      5: 'Muu'
    },
    claimtypeDescription: {
      5: 'Palvelu: kaikenlaiset palvelusopimukset, mm. kauneuden- ja terveydenhoitopalvelut, matkailu- ja majoituspalvelut, taksipalvelut.',
      7: 'Kujetussaatavat: tavaroiden/tuotteiden kuljetukset, ei taksipalvelut.',
      8: 'Irtaimen kauppa: tavaroiden myyntiä koskevat saatavat.',
      14: 'Muu: kaikki saatavat, jotka eivät sovi muihin kategorioihin.',
      2: 'Huoneistovuokra: asuin- ja liikehuoneistojen vuokrat.'
    },
    stepper: {
      start: 'Aloitus',
      orderInfo: 'Toimeksiannon tiedot',
      order: {
        basic: 'Toimeksiannon perustiedot',
        debtors: 'Velallisen tiedot',
        debtor: 'Velallinen',
        bills: 'Laskun tiedot'
      },
      client: 'Perustiedot',
      moneyLaundering: 'Rahanpesuilmoituksen tiedot',
      signing: 'Hyväksyntä ja allekirjoitus'
    },
    labels: {
      companyType: 'Yritysmuoto',
      claimType: 'Laskun peruste',
      amount: 'Avoinna oleva summa',
      billNr: 'Laskun numero',
      additionalInformation: 'Lisätiedot',
      information: 'Laskun kuvaus',
      referenceNr: 'Viitenumero',
      customerNr: 'Asiakasnumero',
      billDate: 'Laskun päiväys',
      dueDate: 'Laskun eräpäivä',
      interestType: 'Viivästyskorko',
      interest: {
        0: 'Korkolain mukainen',
        2: 'Ei korkoa',
        1: 'Sopimuskorko'
      },
      language: 'Kieli',
      streetAddress: 'Katuosoite',
      country: 'Maa',
      companyBusinessId: 'Y-Tunnus', // remove
      phone: 'Puhelin', // remove
      firstName: 'Etunimi',
      lastName: 'Sukunimi',
      businessId: 'Y-Tunnus',
      companyName: 'Yrityksen nimi',
      address: 'Katuosoite',
      postalNumber: 'Postinumero',
      city: 'Paikkakunta',
      phoneNumber: 'Puhelin',
      email: 'Sähköposti',
      socSecNr: 'Henkilötunnus',
      IBAN: 'Tilinumero',
      BIC: 'BIC',
      contactPerson: {
        firstName: 'Yhteyshenkilön etunimi',
        lastName: 'Yhteyshenkilön sukunimi',
        phoneNumber: 'Yhteyshenkilön puhelin',
        email: 'Yhteyshenkilön sähköposti'
      },
      typicalClaim: 'Pääasiallinen saatavan peruste',
      capitalClassification: 'Laskusaatavan pääoman tavanomainen (€) suuruus',
      politicallyInfluentialPerson: 'Poliittisesti vaikutusvaltainen henkilö',
      politicallyInfluentialPersonStatus: 'Poliittinen asema',
      hasNotificationObligation: 'Ilmoitusvelvollisuus',
      needsOperatingLicense: 'Tarvitseeko yrityksenne toiminnalleen toimiluvan?',
      operatingLicenseNameAndAuthority: 'Valvova viranomainen',
      foreignGroupCompany: 'Onko yrityksellänne konserniyhtiöitä ulkomailla?',
      hasBigShareholders: 'Ketkä ovat yrityksenne tosiasialliset edunsaajat?',
      hasPublicStockExchangeInEUCountry: 'Tosiasialliset edunsaajat',
      operatingLicenseNameAndAuthorityLabel: 'Kyllä, toimiluvan nimi ja valvova viranomainen',
      name: 'Nimi',
      shareHolderBirthdayMenu: 'Syntymäaika',
      nationality: 'Kansalaisuus',
      countryOfResidence: 'Asuinmaa',
      groundsOfAuthority: 'Määräysvallan peruste',
      extentOfAuthority: 'Määräysvallan laajuus',
      action: 'Toiminnot',
      companyRepresentativeClaim: 'Edustamisoikeuden peruste',
      selectFile: 'Valitse tiedosto',
      isCompanyRepresentative: 'Kaupparekisteriin merkitty lakimääräinen edustaja',
      powerOfAttorneyFile: 'Valtakirja',
      publicStockExchangeInEUCountryAnswer: 'Yrityksenne osakkeet ovat julkisen kaupankäynnin kohteena',
      vatObligation: 'Yrityksemme on ALV-velvollinen',
      select: 'Valitse',
      yes: 'Kyllä',
      no: 'Ei'
    },
    validationMessages: {
      required: '{attribute} on pakollinen tieto.',
      'required-lite': 'Pakollinen tieto.',
      email: 'Sähköpostiosoite on väärässä muodossa.',
      socSec: 'Henkilötunnus ei ole syötetty oikeassa muodossa.',
      validIBAN: 'Syötä tilinumero IBAN muodossa.',
      underageCreditor: 'Vain täysi-ikäinen henkilö voi rekisteröityä.',
      businessId: 'Y-tunnus on väärässä muodossa, käytä muotoa 1234567-8.',
      postalNumber: 'Postinumero on väärässä muodossa.',
      phoneNumber: 'Puhelinnumero on väärässä muodossa.',
      decimal: '{attribute} on väärässä muodossa.',
      minValue: '{attribute} pitää olla vähintään {min}€.',
      checked: 'Teidän täytyy hyväksyä sopimusehdot.'
    },
    servererror: {
      1: 'Tällä Y-tunnuksella löytyy jo voimassa oleva yhteistyösopimus kanssamme. Pyydämme ottamaan yhteyttä asiakaspalveluumme.',
      2: 'Allekirjoittaminen peruutettu'
    },
    start: {
      header: 'Rekisteröidy Business B2 Impact -palveluun',
      'desc-1': 'Palvelun käyttöönotto vie vain muutaman minuutin, ja samalla voit halutessasi jättää meille ensimmäisen toimeksiannon perintään!',
      'desc-2': 'Rekisteröitymisen yhteydessä sinun tulee tunnistautua ja allekirjoittaa yhteistyösopimus sekä lain edellyttämä rahanpesuilmoitus. Rahanpesuilmoituksen voi allekirjoittaa henkilö, joka on valtuutettu toimimaan yrityksen nimissä nimenkirjoitusoikeuden, valtakirjan tai asemansa perusteella.',
      'desc-3': 'Voit tutustua sopimukseen ja nykyiseen hinnastoon ennen rekisteröitymistä:',
      start: 'Aloita rekisteröityminen',
      addOrder: 'Haluatko samalla jättää laskun perintään?',
      addOrderNow: 'Nyt',
      addOrderLater: 'Myöhemmin',
      addOrderToolTip: 'Rekisteröitymisen yhteydessä voit jättää ensimmäisen toimeksiantosi. Vastaamalla "Nyt" pääset syöttämään toimeksiantoa varten tarvittavat tiedot. Jos samalla asiakkaalla on useampi erääntynyt lasku, voit lisätä ne samaan toimeksiantoon valitsemalla ”Lisää uusi lasku”. Tästä toimeksiannosta lähetämme ensin maksumuistutuksen. Rekisteröitymisen jälkeen voit luoda uusia toimeksiantoja Business B2 Impact -palvelun kautta.',
      isOrderIndisputable: 'Onko lasku riidaton?',
      indisputableTooltip: 'Saatava on riitainen, jos asiakas reklamoi saatavan eli kiistää maksuvelvollisuutensa joko saatavan aiheellisuuden tai euromäärän perusteella. Lain mukaan riitaista saatavaa ei voi periä vapaaehtoisesti',
      indisputableInfo: 'Lain mukaan riitaista saatavaa ei voi periä vapaaehtoisesti. Voit jättää riitaisen asian lakimiehillemme hoidettavaksi ottamalla yhteyttä lakiasianjohtaja Jenni Vainionpäähän (jenni.vainionpaa@b2-impact.com tai 050-3601942)'
    },
    debtor: {
      header: 'Velallisen tiedot',
      'desc-1': 'Syötä seuraavaksi velallista koskevat tiedot.',
      'desc-2': 'Mikäli kyseessä on yritys, pyydämme sinua syöttämään Y-tunnuksen ensin, niin noudamme yrityksen osoitetiedot automaattisesti YTJ-palvelusta.',
      debtor: 'Velallinen',
      partDebtor: 'Osavelallinen',
      addPartDebtor: 'Lisää osavelallinen',
      addPartDebtorTooltip: 'Lisää osavelallinen mikäli velkaa peritään useammalta henkilöltä.'
    },
    bill: {
      header: 'Laskun tiedot',
      desc: 'Syötä laskua koskevat tiedot.',
      addBill: 'Lisää uusi lasku',
      addBillTooltip: 'Huomioithan, että lasku lisätään samaan toimeksiantoon. Kokonaan uuden toimeksiannon lisääminen on mahdollista vasta rekisteröitymisen jälkeen.'
    },
    client: {
      header: 'Perustiedot',
      desc: 'Täytä yrityksen ja yhteyshenkilön tiedot',
      foreignCompanyTooltip: 'Ulkomaalainen yritys tai henkilö, joka haluaa jättää perintätoimeksiannon, pyydetään ottamaan yhteyttä myyntiimme, myynti@b2-impact.fi. Kiitos!',
      contactPerson: 'Yhteyshenkilö',
      IBANTooltip: 'Tarvitsemme yrityksenne tilinumeron mahdollisia tilityksiä varten',
      contactPersonTooltip: 'Yhteyshenkilö on oletusarvoisesti myös Business B2 Impactin pääkäyttäjä',
      vatObligation: 'ALV-velvollisuuden ilmoittaminen'
    },
    moneyLaundering: {
      header: 'Rahanpesuilmoituksen tiedot',
      'desc-1': 'Rahanpesun ja terrorismin rahoittamisen estämisestä annetun lain (444/2017) mukaan  Suomessa toimivien perintätoimistojen  on tunnistettava ja tunnettava asiakkaansa.',
      'desc-2': 'Sanotun velvollisuuden täyttämiseksi, pyydämme teitä täyttämään seuraavat tiedot:',
      politicallyInfluentialPersonCaption: 'Onko viimeksi kuluneen vuoden aikana yrityksenne johdossa, hallituksessa tai tosiasiallisena edunsaajana ollut henkilö, joka on poliittisesti vaikutusvaltainen (PEP)?',
      politicallyInfluentialPersonTooltip: 'Poliittisesti vaikutusvaltaisena henkilönä pidetään henkilöä, joka on viimeksi kuluneen vuoden aikana toiminut Suomen tai toisen valtion ylemmässä virkatehtävässä tai luottamustoimessa, kuten valtionpäämiehenä, ylimpien tuomioistuinten jäsenenä tai keskuspankin johtokunnan jäsenenä. Henkilö katsotaan olevan poliittisesti vaikutusvaltainen myös, jos henkilön perheenjäsen tai yhtiökumppani on poliittisesti vaikutusvaltainen.',
      politicallyInfluentialPersonStatusLabel: 'Kyllä, poliittinen asema',
      operatingLicenseNameAndAuthorityLabel: 'Kyllä, toimiluvan nimi ja valvova viranomainen',
      hasNotificationObligationCaption: 'Onko yrityksenne Suomen Rahanpesulain tai EU:n rahanpesudirektiivin (EU 2015/849) mukainen ilmoitusvelvollinen?',
      hasBigShareholdersCaption: 'Koska vastastitte, että yrityksellänne on konserniyhtiöitä (myös) muualla kuin EU- tai ETA- maissa, pyydämme vastaamaan seuraavaan kysymykseen:<br>Ketkä ovat yrityksenne tosiasialliset edunsaajat?',
      bigShareholderTooltip: '<p>Rahanpesulain mukaisella tosiasiasiallisella edunsaajalla tarkoitetaan henkilöä, joka joko osuuksiensa johdosta tai äänimääräjärjestelyillä käyttää tosiasiallista määräysvaltaa yhtiössä.</p><p>Yhteisön tosiasiallisella edunsaajalla tarkoitetaan luonnollista henkilöä, joka viime kädessä omistaa suoraan tai välillisesti suuremman kuin 25 % osuuden oikeushenkilön osakkeista tai muuten omistaa vastaavan osuuden oikeushenkilöstä.</p><ol><li>Henkilö 1 omistaa 26 % osakeyhtiön A osakekannasta. Henkilö 1 on tosiasiallinen edunsaaja Osoituksena välillisestä omistuksesta pidetään sitä, että oikeushenkilöllä, jossa yksi tai useampi luonnollinen henkilö käyttää itsenäistä päätösvaltaa, on suurempi kuin 25 % omistusosuus tai suurempi kuin 25 % osuus äänioikeuksista tarkasteltavasta oikeushenkilöstä.</li><li>Henkilö 1 omistaa 32 %, Henkilö 2 30 % ja Yritys B 28 % osakeyhtiön A osakekannasta. Henkilö 3 omistaa 53 % Yritys B:n osakekannasta. Tosiasiallisia edunsaajia osakeyhtiössä A ovat henkilöiden 1 ja 2 lisäksi henkilö 3, sillä tämä käyttää epäsuoraa määräysvaltaa myös osakeyhtiössä A omistaessaan enemmistön Yritys B:n osakekannasta.</li><li>Yritys B, C ja D omistavat kukin 10 % osakeyhtiöstä A. Henkilö 1 omistaa Yrityksen B, C ja D 100 % omistusosuudella. Henkilö 1 on osakeyhtiön A tosiasiallinen edunsaaja</li></ol>',
      hasBigShareholdersFalse: 'Yrityksessämme tosiasiallisen edunsaajan määritelmä ei täyty, jolloin tosiasiallisina edunsaajina pidetään Rahanpesulain mukaisesti yhtiömme hallitusta tai vastuunalaista yhtiömiestä, toimitusjohtajaa tai muuta vastaavassa asemassa olevaa henkilöä',
      hasBigShareholdersTrue: 'Yhtiössämme tosiasiallisen edunsaajan määritelmä täyttyy',
      hasPublicStockExchangeInEUCountryCaption: 'Ovatko yrityksenne osakkeet julkisen kaupankäynnin kohteena joko EU:n tai ETA- alueen arvopaperipörssissä?',
      hasPublicStockExchangeInEUCountryTrue: 'Kyllä, missä maassa?',
      hasPublicStockExchangeInEUCountryFalse: 'Ei. Ketkä ovat yrityksenne tosiasialliset edunsaajat?',
      'foreignGroupCompanyAnswer-1': 'EU- tai ETA-maissa',
      'foreignGroupCompanyAnswer-2': '(myös) muualla kuin EU- tai ETA- maissa; missä?',
      footer: 'B2 Impact käyttää tunnistamislomakkeesta saamiaan tietoja ainoastaan Rahanpesulaissa määriteltyihin tarkoituksiin. Tunnistamistietoja voidaan käyttää mm. rahanpesun ja terrorismin rahoittamisen estämiseen, paljastamiseen ja selvittämiseen. Yhtiö  säilyttää näitä tietoja viisi vuotta asiakkuussuhteen päättymisestä.',
      addNewShareholder: 'Lisää uusi edunsaaja',
      editShareholder: 'Muokkaa edunsaajaa',
      removeShareholder: 'Poista edunsaaja',
      removeShareholderQuestion: 'Haluatko poistaa edunsaajan:',
      companyRepresentativePosition: 'Valtuutettu aseman perusteella. Asema yrityksessä: '
    },
    signing: {
      header: 'Hyväksyntä ja allekirjoitus',
      'desc-1': 'Melkein valmista! Ennen palvelun käytön aloittamista sinun tulee vielä allekirjoittaa toimeksiantosopimus sekä rahanpesuilmoitus.Muistathan, että rahanpesuilmoituksen voi allekirjoittaa henkilö, joka on valtuutettu toimimaan yrityksen nimissä nimenkirjoitusoikeuden, valtakirjan tai asemansa perusteella.',
      'desc-2': 'Rekisteröityminen edellyttää myös, että hyväksyt palvelua koskevat sopimusehdot.',
      contractAgreement: 'Sopimusehtojen ja hinnaston hyväksyntä',
      contractAccept: 'Hyväksyn',
      digitalSignature: 'Sähköinen allekirjoitus',
      'digitalSignatureDesc-1': 'Syötä henkilötietosi, ja jatka sitten allekirjoittamaan dokumentit.',
      'digitalSignatureDesc-2': 'Tunnistautuminen ja allekirjoittaminen tehdään Signicat- palvelussa.Prosessin jälkeen sinut ohjataan automaattisesti takaisin, ja pääset aloittamaan Business B2 Impactin käytön.',
      sign: 'Allekirjoita'
    },
    complete: {
      'wait-header': 'Ole hyvä ja odota hetki.',
      'wait-desc': 'Viimeistelemme rekisteröitymistä.',
      'success-header': 'Tervetuloa Business B2 Impact -verkkopalvelumme käyttäjäksi!',
      'fail-header': 'Hupsista, tapahtui virhe!',
      'fail-desc': 'Syöttämäsi tiedot on tallennettu ja otamme sinuun yhteyttä mahdollisimman pian.',
      'success-desc-1': 'Olet nyt rekisteröitynyt Business B2 Impact -palveluun ja käyttäjätunnuksesi on lähetetty sähköpostiisi:',
      'success-desc-2': 'Otathan meihin yhteyttä, jos sinulla on jotain palveluun liittyviä kysymyksiä. Autamme mielellämme.',
      'businessb2impactLink': 'Siirry tästä Business B2 Impact -palveluun'
    },
    summary: 'Yhteenveto syötetyistä tiedoista',
    navigation: {
      desc: 'Yllä olevasta valikosta näet, miten rekisteröinti etenee. Voit tarvittaessa palata takaisin haluamaasi vaiheeseen klikkaamalla valikon otsikoita.'
    },
    ytj: {
      header: 'Osoitetietojen tuonti',
      'text-1': 'Y-tunnuksella',
      'text-2': 'löytyi',
      question: 'Haluatteko tuoda osoitetiedot?'
    }
  },
  se: {
    common: {
      yes: 'Ja',
      no: 'Nej',
      continue: 'Fortsätt',
      title: 'Är du ny kund, registrera dig här!',
      company: 'Företag',
      person: 'Person',
      bill: 'Faktura',
      save: 'Spara',
      cancel: 'Avbryt',
      close: 'Stäng',
      finland: 'Finland'
    },
    companyType: {
      0: '',
      1: 'Aktiebolag',
      2: 'Kommanditbolag',
      3: 'Öppet bolag',
      4: 'Privat företagare',
      5: 'Stiftelse',
      6: 'Förening',
      7: 'Offentligt bolag',
      8: 'Andelslag',
      9: 'Sidoverksamhet',
      10: 'Övrig'
    },
    claimType: {
      5: 'Tjänst',
      7: 'Transportavtal',
      8: 'Handel med lösöre',
      14: 'Annat',
      2: 'Hyra'
    },
    typicalClaim: {
      1: 'Konsumtionskredit',
      2: 'Rumshyra',
      3: 'Avbetalningsköp',
      4: 'Post- /internetköp',
      5: 'Serviceavtal',
      6: 'Skuldbrev',
      7: 'Transportavtal',
      8: 'Handel med lösöre',
      9: 'Naturprodukter',
      10: 'Gymfordran',
      11: 'Elfordran',
      12: 'Övervakningsavgift',
      13: 'Försäkring',
      14: 'Annan grund',
      15: 'Smålån',
      16: 'Tidning/Annons',
      17: 'Vatten- och avloppfordran',
      18: 'Annan hyra',
      19: 'Person-till-person-lån'
    },
    claimtypeDescription: {
      5: 'Tjänst: allehanda avtalstjänster skönhets- och hälsovårdstjänster, rese- och övernattningstjänster, taxitjänster mm.',
      7: 'Transportfordringar: Transport av varor, inte taxitjänster.',
      8: 'Handel med lösöre: fordringar som gäller försäljning av lösöre.',
      14: 'Annat: alla fordringar som inte passar in i de övriga kategorierna',
      2: 'Hyra: hyra för bostads- och affärslägenheter.'
    },
    languages: {
      1: 'Finska',
      2: 'Svenska',
      3: 'Engelska',
      4: 'Tyska',
      6: 'Estniska',
      7: 'Ryska',
      5: 'Andra'
    },
    stepper: {
      start: 'Start',
      orderInfo: 'Uppdragets uppgifter',
      order: {
        basic: 'Uppdragets grunduppgifter',
        debtors: 'Uppgifter om gäldenären',
        debtor: 'Gäldenär',
        bills: 'Fakturans uppgifter'
      },
      client: 'Basinformation',
      moneyLaundering: 'Uppgifterna i anmälan om penningtvätt',
      signing: 'Godkännande och underteckning'
    },
    labels: {
      companyType: 'Bolagsform',
      claimType: 'Fakturans grund',
      amount: 'Obetald summa',
      billNr: 'Fakturanummer',
      additionalInformation: 'Tilläggsuppgifter',
      information: 'Fakturabeskrivning',
      referenceNr: 'Referensnummer',
      customerNr: 'Kundnummer',
      billDate: 'Fakturadatum',
      dueDate: 'Fakturans förfallodag',
      interestType: 'Förseningsränta',
      interest: {
        0: 'Enligt räntelagen',
        2: 'Ingen ränta',
        1: 'Avtalad ränta'
      },
      language: 'Språk',
      streetAddress: 'Adress',
      country: 'Land',
      companyBusinessId: 'FO-nummer',
      phone: 'Telefon',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      businessId: 'FO-nummer',
      companyName: 'Företagets namn',
      address: 'Adress',
      postalNumber: 'Postnummer',
      city: 'Ort',
      phoneNumber: 'Telefon',
      email: 'E-post',
      socSecNr: 'Personnummer',
      IBAN: 'Kontonummer',
      BIC: 'BIC',
      contactPerson: {
        firstName: 'Kontaktpersonens förnamn',
        lastName: 'Kontaktpersonens efternamn',
        phoneNumber: 'Kontaktpersonens telefonnummer',
        email: 'Kontaktpersonens E-post'
      },
      typicalClaim: 'Grunden för den huvudsakliga fodran',
      capitalClassification: 'Huvudsakligt kapitalbelopp för fakturafodran',
      politicallyInfluentialPerson: 'Person i politiskt utsatt ställning',
      politicallyInfluentialPersonStatus: 'Politisk ställning',
      hasNotificationObligation: 'Anmälningsplikt',
      needsOperatingLicense: 'Behöver ert bolag tillstånd för sin verksamhet?',
      operatingLicenseNameAndAuthority: 'Tillsynsmyndighet',
      foreignGroupCompany: 'Har ert bolag koncernbolag utomlands?',
      hasBigShareholders: 'Vilka är ert bolags verkliga förmånstagare?',
      hasPublicStockExchangeInEUCountry: 'Verkliga förmånstagare',
      operatingLicenseNameAndAuthorityLabel: 'Kyllä, toimiluvan nimi ja valvova viranomainen',
      name: 'Namn',
      shareHolderBirthdayMenu: 'Födelsetid',
      nationality: 'Nationalitet',
      countryOfResidence: 'Hemland',
      groundsOfAuthority: 'Grund för bestämmande inflytande',
      extentOfAuthority: 'Det bestämmande inflytandet inbegriper',
      companyRepresentativeClaim: 'Grund för representationsrätt',
      selectFile: 'Välj fil',
      action: 'Funktioner',
      isCompanyRepresentative: 'I handelsregistret antecknad laglig företrädare',
      powerOfAttorneyFile: 'Fullmakt',
      publicStockExchangeInEUCountryAnswer: 'Ert bolags aktier är föremål för offentlig handel på fondbörsen',
      vatObligation: 'Vårt företag bedriver momsskyldigt verksamhet',
      select: 'Välj',
      yes: 'Ja',
      no: 'Nej'
    },
    validationMessages: {
      required: '{attribute} är obligatorisk information.',
      'required-lite': 'Obligatorisk information.',
      email: 'E-postadressen är i fel format.',
      socSec: 'Personnumret är inte ifyllt i rätt format.',
      validIBAN: 'Fyll i kontonumret i IBAN format.',
      underageCreditor: 'Endast en myndig person kan registrera sig.',
      businessId: 'FO-numret är i fel format, använd format 1234567-8.',
      postalNumber: 'Postnumret är i fel format.',
      phoneNumber: 'Telefonnumret är i fel format.',
      decimal: '{attribute} är i fel format.',
      minValue: '{attribute} måste vara större än {min}€.',
      checked: 'Du måste godkänna avtalsvillkoren'
    },
    servererror: {
      1: 'Vi har redan ett ikraftvarande samarbetsavtal registrerat på denna FO-nummer. Vänligen kontakta vår kundservice.',
      2: 'Allekirjoittaminen peruutettu'
    },
    start: {
      header: 'Registrera dig på tjänsten Business B2 Impact',
      'desc-1': 'Det tar bara ett par minuter att ta tjänsten i bruk.Efter slutförd registrering kan du genast lämna in uppdrag för indrivning.',
      'desc-2': 'I samband med registreringen måste du identifiera dig och underteckna samarbetsavtalet och anmälan om penningtvätt som lagen kräver. En penningtvättsanmälan kan signeras av en person som är behörig att agera på företagets vägnar baserat på deras signaturrätt, fullmakt eller position i företaget.',
      'desc-3': 'Du kan bekanta dig med avtalet och ikraftvarande prislista före registreringen:',
      start: 'Påbörja registreringen',
      addOrder: 'Vill du samtidigt lämna in en faktura på inkasso?',
      addOrderNow: 'Nu',
      addOrderLater: 'Senare',
      addOrderToolTip: 'I samband med registreringen kan du lämna in ditt första uppdrag. Genom att svara "Nu" kan du fylla i alla uppdragets uppgifter vi behöver. Om samma gäldenär har flera förfallna fakturor kan du sätta till dem till samma uppdrag genom att välja "Lägg till ny faktura". Innan vi flyttar uppdraget till inkasso sänder vi en betalningspåminnelse. Efter registreringen kan du föra över nya uppdrag via Business B2 Impact -tjänsten.',
      isOrderIndisputable: 'Är fakturan klar och ostridig?',
      indisputableTooltip: 'Fordran är stridig om kunden har reklamerat fordran, dvs. om kunden har bestridit sin betalningsskyldighet med hänvisning till fordrans grund eller belopp. Enligt lag kan en stridig fordran inte drivas in frivilligt.',
      indisputableInfo: 'Enligt lag kan en stridig fordran inte drivas in frivilligt. Du kan överlåta behandlingen av en stridig fordran till våra jurister genom att ta kontakt med Jenni Vainionpää, direktör för juridiska ärenden (jenni.vainionpaa@b2-impact.com eller 050-3601942).'
    },
    debtor: {
      header: 'Uppgifter om gäldenären',
      'desc-1': 'Mata in uppgifterna gällande gäldenären.',
      'desc-2': 'Om det gäller ett företag, ber vi dig mata in FO-nummern först så hämtar vi automatiskt företagets adressuppgifter  från YTJ-tjänsten.',
      debtor: 'Gäldenär',
      partDebtor: 'Delgäldenär',
      addPartDebtor: 'Lägg till delgäldenär',
      addPartDebtorTooltip: 'Lägg till en delgäldenär om skulden skall krävas in av flera personer.'
    },
    bill: {
      header: 'Fakturans uppgifter',
      desc: 'Mata in fakturans uppgifter.',
      addBill: 'Lägg till ny faktura',
      addBillTooltip: 'Observera, att fakturan läggs till samma uppdrag. Att mata in ett nytt uppdrag är möjligt först då registreringen är slutförd.'
    },
    client: {
      header: 'Basinformation',
      desc: 'Fyll i företagets och kontaktpersonens uppgifter.',
      foreignCompanyTooltip: 'Utländska företag och personer som vill lämna in ett uppdrag till inkasso, ombeds kontakta vår försäljning, myynti@b2-impact.fi. Tack!',
      contactPerson: 'Kontaktperson',
      IBANTooltip: 'Vi behöver företagets kontonummer(IBAN) för att eventuella redovisningar',
      contactPersonTooltip: 'Kontaktpersonen blir automatiskt även er huvudanvändare för Business B2 Impact',
      vatObligation: 'Momsskyldighet'
    },
    moneyLaundering: {
      header: 'Uppgifterna i anmälan om penningtvätt',
      'desc-1': 'Enligt lagen (444/2017) om förhindrande av penningtvätt och av terrorism, bör indrivningsbyråer med verksamhet i Finland identifiera sina kunder och känna till deras identitet.',
      'desc-2': 'För att uppfylla skyldigheten som grundar sig på lagen om penningtvätt  ber vi er fylla i följande uppgifter:',
      politicallyInfluentialPersonCaption: 'Har ni haft/ har det i ledningen, styrelsen eller som verklig förmånstagare för ert företag funnits en person i politiskt utsatt ställning under det gångna året (PEP)?',
      politicallyInfluentialPersonTooltip: 'Person, som under det gångna året i Finland eller i en annan stat innehaft ett högre tjänsteuppdrag eller förtroendeuppdrag, såsom statsöverhuvud, ledamot i en av de högsta domstolarna eller ledamot i direktionen för en centralbank. Personen anses även inneha en politiskt utsatt ställning, om personens familjemedlem eller bolagsman är i en politiskt utsatt ställning.',
      politicallyInfluentialPersonStatusLabel: 'Ja, politisk ställning',
      operatingLicenseNameAndAuthorityLabel: 'Ja, namn på tillståndet och tillsynsmyndigheten',
      hasNotificationObligationCaption: 'Är ert bolag anmälningspliktigt enligt lagen om penningtvätt eller EU:s direktiv för förhindrandet av penningtvätt (EU 2015/849)',
      hasBigShareholdersCaption: 'Eftersom ni svarade att ert bolag (även) har koncernbolag i andra länder än i EU- eller EES -medlemsländer, ber vi att ni svarar på följande fråga:<br>Vilka är ert bolags verkliga förmånstagare?',
      bigShareholderTooltip: '<p>I lagen om penningtvätt avser verkliga förmånstagare personer som antingen med anledning av sina andelar eller genom arrangemang med röstetal faktiskt utövar ett bestämmande inflytande i bolaget.</p><p>Med en sammanslutnings verkliga förmånstagare avses en fysisk person som ytterst direkt eller indirekt äger mer än 25 procent av aktierna i den juridiska personen eller annars en motsvarande andel i den juridiska personen.</p><ol><li>Person 1 äger 26 procent av aktiestocken i aktiebolag A. Person 1 är den verkliga förmånstagaren</li><li>Person 1 äger 32 procent, Person 2 30 procent och Företag B 28 procent av aktiestocken i aktiebolag A. Person 3 äger 53 procent av aktiestocken i Företag B. De verkliga förmånstagarna i aktiebolag A är förutom personerna 1 och 2 även person 3, eftersom denna utövar ett indirekt bestämmande inflytande även i aktiebolag A genom att äga majoriteten av aktiestocken i Företag B</li><li>Företag B, C och D äger vardera 10 procent av aktiebolag A. Person 1 äger Företag B, C och D med en ägarandel på 100 procent. Person 1 är verklig förmånstagare i aktiebolag A.</li></ol>',
      hasBigShareholdersFalse: 'Inom företaget uppfylls inte definitionen av en verklig förmånstagare, varpå den verkliga förmånstagaren i enlighet med lagen om penningtvätt avser bolagets styrelse eller ansvarig bolagsman, verkställande direktör eller annan person i ansvarsposition.',
      hasBigShareholdersTrue: 'Inom företaget uppfylls definitionen av en verklig förmånstagare',
      hasPublicStockExchangeInEUCountryCaption: 'Är ert bolags aktier föremål för offentlig handel på fondbörsen antingen i EU- eller i EES-området?',
      hasPublicStockExchangeInEUCountryTrue: 'Ja, i vilket land?',
      hasPublicStockExchangeInEUCountryFalse: 'Nej, vilka är ert bolags verkliga förmånstagare?',
      'foreignGroupCompanyAnswer-1': 'EU-medlemsländer/EES-området',
      'foreignGroupCompanyAnswer-2': 'Även i andra länder än i EU- medlemsländer/EES- området ; var?',
      footer: 'B2 Impact använder  de uppgifter som fås från identifieringsblanketten till de syften som avses i lagen om Penningtvätt. Identifieringsuppgifterna kan användas bl.a. till att förhindra och avslöja samt utreda ärenden rörande penningtvätt och finansiering av terrorism. Bolaget sparar dessa uppgifter i fem år efter att kundrelationen upphört.',
      addNewShareholder: 'Fyll i ny förmånstagare',
      editShareholder: 'Editera förmånstagare',
      removeShareholder: 'Ta bort förmånstagare',
      removeShareholderQuestion: 'Vill du ta bort förmånstagare:',
      companyRepresentativePosition: 'Signaturrätt baserad på position. Roll i företaget: '
    },
    signing: {
      header: 'Godkännande och underteckning',
      'desc-1': 'Nästan klart! Före du kan ta tjänsten i bruk bör du ännu underteckna samarbetsavtalet och anmälan om penningtvätt.',
      'desc-2': 'En penningtvättsanmälan kan signeras av en person som är behörig att agera på företagets vägnar baserat på deras signaturrätt, fullmakt eller position i företaget.',
      contractAgreement: 'Godkännande av avtalsvillkor och prislista',
      contractAccept: 'Jag godkänner',
      digitalSignature: 'Elektronisk underskrift',
      digitalSignatureDesc: 'Identifiera dig med dina nätbankskoder',
      'digitalSignatureDesc-1': 'Mata in dina personuppgifter och gå vidare för att underteckna dokumenten.',
      'digitalSignatureDesc-2': 'Du styrs till Signicat-tjänsten för att identifiera dig och underteckna dokumenten. Då du undertecknat dokumenten styrs du automatiskt tillbaka till Business B2 Impact-sidan och kan börja använda tjänsten.',
      sign: 'Underteckna'
    },
    complete: {
      'wait-header': 'Var god och dröj.',
      'wait-desc': 'Vi slutför din registrering.',
      'success-header': 'Välkommen till vår Business B2 Impact-webbtjänst!',
      'fail-header': 'Hoppsan, nåt gick snett!',
      'fail-desc': 'Informationen du matat in är sparad och vi kontaktar dig så fort som möjligt.',
      'success-desc-1': 'Du är nu registrerad som användare i Business B2 Impact -tjänsten och inloggningsuppgifterna har sänts till din e-post:',
      'success-desc-2': 'Vänligen ta kontakt om du har frågor gällande tjänsten. Vi hjälper gärna.',
      'businessb2impactLink': 'Gå vidare till Business B2 Impact'
    },
    summary: 'Sammanfattning av ifyllda uppgifter',
    navigation: {
      desc: 'I menyn här ovanför ser du hur registreringen framskrider. Genom att klicka på rubriken i menyn, kan du vid behov återgå till ett tidigare skede.'
    },
    ytj: {
      header: 'Hämtning av adressuppgifter',
      'text-1': 'På FO-nummret',
      'text-2': 'hittas',
      question: 'Vill du hämta adressuppgifterna?'
    }
  },
  en: {
    common: {
      yes: 'Yes',
      no: 'No',
      title: 'New customer? Register here!',
      continue: 'Continue',
      company: 'Company',
      person: 'Private individual',
      bill: 'Invoice',
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      finland: 'Finland'
    },
    companyType: {
      0: '',
      1: 'Limited company',
      2: 'Limited partnership',
      3: 'General Partnership',
      4: 'Private entrepreneur',
      5: 'Institution',
      6: 'Association',
      7: 'Public company',
      8: 'Cooperative',
      9: 'Branch',
      10: 'Other'
    },
    claimType: {
      5: 'Service',
      7: 'Transport',
      8: 'Movables commerce',
      14: 'Other',
      2: 'Rent'
    },
    typicalClaim: {
      1: 'Consumer credit',
      2: 'Room rent',
      3: 'Installment purchase',
      4: 'Mail-order / e-commerce',
      5: 'Service agreement',
      6: 'IOU / Note',
      7: 'Transport agreement',
      8: 'Movables commerce',
      9: 'Natural products',
      10: 'Health club',
      11: 'Electricity commerce',
      12: 'Control fee',
      13: 'Insurance',
      14: 'Other',
      15: 'Micro loans',
      16: 'Newspaper / Advertisement / Publishing',
      17: 'Water and sewer receivables',
      18: 'Other rent',
      19: 'Peer-to-peer credit'
    },
    languages: {
      1: 'Finnish',
      2: 'Swedish',
      3: 'English',
      4: 'German',
      6: 'Estonian',
      7: 'Russian',
      5: 'Other'
    },
    claimtypeDescription: {
      5: 'Service: all kinds of service contracts, incl. beauty and healthcare services, tourism and accommodation services, taxi services.',
      7: 'Transport receivables: transports of goods/products, not taxi services.',
      8: 'Movable property store: receivables relating to the sale of goods.',
      14: 'Other: all receivables that do not fit into the other categories.',
      2: 'Rent: residential and commercial property rents.'
    },
    stepper: {
      start: 'Start',
      orderInfo: 'Assignment information',
      order: {
        basic: 'Basic information',
        debtors: 'Debtor information',
        debtor: 'Debtor',
        bills: 'Invoice information'
      },
      client: 'Basic information',
      moneyLaundering: 'Money laundering report',
      signing: 'Approval and signature'
    },
    labels: {
      companyType: 'Company type',
      claimType: 'Grounds for the claim',
      amount: 'Amount outstanding',
      billNr: 'Invoice number',
      additionalInformation: 'Additional information',
      information: 'Description of the invoice',
      referenceNr: 'Reference number',
      customerNr: 'Customer number',
      billDate: 'Invoice date',
      dueDate: 'Invoice due date',
      interestType: 'Penalty Interest',
      interest: {
        0: 'Legal Interest',
        2: 'No interest',
        1: 'Contract Interest'
      },
      language: 'Language',
      streetAddress: 'Street address',
      country: 'Country',
      companyBusinessId: 'Business Id', // remove
      phone: 'Phone', // remove
      firstName: 'First name',
      lastName: 'Last name',
      businessId: 'Business Id',
      companyName: 'Company name',
      address: 'Street address',
      postalNumber: 'Post code',
      city: 'City',
      phoneNumber: 'Phone',
      email: 'Email',
      socSecNr: 'Social security number',
      IBAN: 'Bank account',
      BIC: 'BIC',
      contactPerson: {
        firstName: 'Contact persons first name',
        lastName: 'Contact persons last name',
        phoneNumber: 'Contact persons phone',
        email: 'Contact persons email'
      },
      typicalClaim: 'Typical claim type',
      capitalClassification: 'Typical invoice outstanding amount',
      politicallyInfluentialPerson: 'Politically exposed person',
      politicallyInfluentialPersonStatus: 'Political position',
      hasNotificationObligation: 'Reporting obligation',
      needsOperatingLicense: 'Does your company need a license for operation?',
      operatingLicenseNameAndAuthority: 'Supervising authority',
      foreignGroupCompany: 'Does your company have group companies abroad?',
      hasBigShareholders: 'Who are your company\'s actual beneficial owners?',
      hasPublicStockExchangeInEUCountry: 'Beneficial owners',
      operatingLicenseNameAndAuthorityLabel: 'Yes, the name of the license and the supervising authority',
      name: 'Name',
      shareHolderBirthdayMenu: 'Date of birth',
      nationality: 'Nationality',
      countryOfResidence: 'Country of residence',
      groundsOfAuthority: 'Grounds of authority',
      extentOfAuthority: 'Extent of authority',
      action: 'Actions',
      companyRepresentativeClaim: 'Grounds for representation rights',
      selectFile: 'Choose a file',
      isCompanyRepresentative: 'Statutory representative recorded in the register',
      powerOfAttorneyFile: 'Power of attorney',
      publicStockExchangeInEUCountryAnswer: 'Company\'s shares are publicly traded',
      vatObligation: 'Our company is liable to pay VAT',
      select: 'Select',
      yes: 'Yes',
      no: 'No'
    },
    validationMessages: {
      required: '{attribute} is mandatory information.',
      'required-lite': 'Mandatory information.',
      email: 'The email address is in the incorrect format.',
      socSec: 'The personal identification number was not entered in the correct format.',
      validIBAN: 'Enter the account number in IBAN format.',
      underageCreditor: 'Only persons over 18 years of age can be registered.',
      businessId: 'The business ID is in the incorrect format, use the format 1234567-8.',
      postalNumber: 'The postcode is in the incorrect format.',
      phoneNumber: 'The telephone number is in the incorrect format.',
      decimal: '{attribute} is in the incorrect format.',
      minValue: '{attribute} must be at least {min}€.',
      checked: 'You need to accept the terms of service.'
    },
    servererror: {
      1: 'We found an existing contract with this Business Id. Please contact our customer service.',
      2: 'The signing was cancelled'
    },
    start: {
      header: 'Business B2 Impact - register as a new user',
      'desc-1': 'Registration takes only a few minutes, and you have the option to submit your first assignment to collection right away.',
      'desc-2': 'During the registration process, we need you to sign the service agreement as well as the mandatory money laundering report with your electronic signature. A money laundering report can be signed by a person who is authorized to act on behalf of the company based on their signature right, power of attorney, or position in the company.',
      'desc-3': 'You can familiarize yourself with the contract and the current price list before registering: ',
      start: 'Start registration',
      addOrder: 'At the same time, would you like to submit an invoice for collection?',
      addOrderNow: 'Now',
      addOrderLater: 'Later',
      addOrderToolTip: 'In connection with registration, you can submit your first assignment. By answering "yes" you can enter the information required for the assignment: Invoice and debtor customer information. If the same customer has multiple overdue invoices, you can add them to the same assignment by selecting “Add invoice”. We will first send a payment reminder for this order. After registration, you can create new assignments and select whether we will send a payment reminder or a payment demand. Sending a payment demand requires that a reminder has been sent for the overdue invoice before transfer to debt collection.',
      isOrderIndisputable: 'Is the invoice undisputed?',
      indisputableTooltip: 'The receivable is disputed if the customer has made a complaint regarding their obligation to pay the debt on the basis of the grounds for the debt or the amount. According to law, it is not allowed to voluntarily collect a disputed receivable.',
      indisputableInfo: 'According to law, it is not allowed to voluntarily collect a disputed receivable. You can hand over the handling of a disputed debt to our lawyers by contacting Jenni Vainionpää, Chief Legal and Compliance officer (jenni.vainionpaa@b2-impact.com or 050-3601942).'
    },
    debtor: {
      header: 'Debtor information ',
      'desc-1': 'Enter the following information about the debtor.',
      'desc-2': 'If the debtor is a company, please enter the business ID first, so we can automatically retrieve the company\'s address information from the YTJ business information system.',
      debtor: 'Debtor',
      partDebtor: 'Partial debtor',
      addPartDebtor: 'Add a partial debtor',
      addPartDebtorTooltip: 'Add a partial debtor if the debt will be collected from more than one person / if more than one person is responsible for the debt. (not a guarantor)'
    },
    bill: {
      header: 'Invoice information',
      desc: 'Enter information about the invoice.',
      addBill: 'Add a new invoice',
      addBillTooltip: 'Please note that the invoice will be added to the same assignment. Adding a new assignment is possible only after registration.'
    },
    client: {
      header: 'Basic information',
      desc: 'Enter company and contact persons information.',
      foreignCompanyTooltip: 'A foreign company or person wishing to submit a collection assignment is requested to contact our sales team, sales@b2-impact.fi. Thank you!',
      contactPerson: 'Contact person',
      IBANTooltip: 'We need your company’s account number for making settlements',
      contactPersonTooltip: 'The contact person will also be the Business B2 Impact admin user',
      vatObligation: 'Liability for VAT (Value Added Tax)'
    },
    moneyLaundering: {
      header: 'Money laundering report',
      'desc-1': 'Under the Act on Preventing Money Laundering and Terrorist Financing (444/2017), debt collection companies operating in Finland must identify and know their clients.',
      'desc-2': 'In order to comply with this obligation, we ask you to complete the following information:',
      politicallyInfluentialPersonCaption: 'Has a politically exposed person (PEP) acted in your company’s management, Board or as a beneficial owner (a shareholder whose stake exceeds 25% of shares or stake in your company) over the past year?',
      politicallyInfluentialPersonTooltip: 'A politically exposed person is deemed to be a person who, during the past year, has held a senior official position or position of trust in Finland or another state, such as a head of state, a member of a supreme court or a member of the board of a central bank. A person is also deemed to be a politically exposed person if a member of the person’s family or a partner is a political exposed person.',
      politicallyInfluentialPersonStatusLabel: 'Yes, political position',
      operatingLicenseNameAndAuthorityLabel: 'Yes, the name of the license and the supervising authority',
      hasNotificationObligationCaption: 'Does your company have reporting obligation according to the Finnish Act on Money Laundering, or according to EU\'s money laundering directive (EU 2015 / 849)?',
      hasBigShareholdersCaption: 'Since you have indicated that your company has groupcompanies in other than EU- and ETA-countries, we kindly ask you to answer the following question:<br>Who are the beneficial owners in your company?',
      bigShareholderTooltip: '<p>A beneficial owner as specified in the Act on Money Laundering refers to a person who holds control in the company either through their holdings or voting right arrangements.</p><ol><li>Person 1 holds 26% of shares in limited company A. Person 1 is the beneficial owner</li><li>Person 1 holds 32%, person 2 30% and company B 28% of shares in limited company A. Person 3 holds 53% of shares in company B. Beneficial owners in limited company A include persons 1 and 2 as well as person 3 as they also hold indirect control in limited company A as they own a majority stake in company B</li><liCompany B, C and D each own 10% of limited company A. Person 1 owns company B, C and D through a holding of 100%. Person 1 is the beneficial owner in limited company A.</li></ol>',
      hasBigShareholdersFalse: 'In our company the definition of beneficial owner is not fulfilled and therefore in accordance with the Act on Money Laundering the beneficial owners can be seen as the board of directors or general partner, CEO or other person in a similar position',
      hasBigShareholdersTrue: 'In our company, the definition of a beneficial owner is fulfilled',
      hasPublicStockExchangeInEUCountryCaption: 'Are the shares in your company publicly traded in a stock exchange either within the EU or EEA?',
      hasPublicStockExchangeInEUCountryTrue: 'Yes, in which country?',
      hasPublicStockExchangeInEUCountryFalse: 'No. Who are the beneficial owners?',
      'foreignGroupCompanyAnswer-1': 'EU or EEA countries',
      'foreignGroupCompanyAnswer-2': 'also in other countries than EU or EEA countries; where?',
      footer: 'B2 Impact will use the information it obtains from the identification form only for the purposes specified in the Money Laundering Act. Identification information can be used e.g. for the prevention, detection and investigation of money laundering and terrorist financing. The company retains this information for five years after the ending of the customer relationship.',
      addNewShareholder: 'Add new shareholder',
      editShareholder: 'Edit shareholder',
      removeShareholder: 'Remove shareholder',
      removeShareholderQuestion: 'Do you want to remove the shareholder:',
      companyRepresentativePosition: 'Authorization based on position. Position in the company: '
    },
    signing: {
      header: 'Approval and signature',
      'desc-1': 'Almost there! Before you can start using the service, you need to sign the service agreement as well as the mandatory money laundering report.',
      'desc-2': 'A money laundering report can be signed by a person who is authorized to act on behalf of the company based on their signature right, power of attorney, or position in the company.',
      contractAgreement: 'Approval of the contract terms and price liste',
      contractAccept: 'I accept the',
      digitalSignature: 'Electronic signature',
      'digitalSignatureDesc-1': 'Please provide your personal information, and then proceed to sign the documents.',
      'digitalSignatureDesc-2': 'The authentication and signing are done with Signicat.After the process is complete, you will be redirected back automatically, and can then login to Business B2 Impact.',
      sign: 'Sign'
    },
    complete: {
      'wait-header': 'Please wait',
      'wait-desc': 'We are finalizing your registration.',
      'success-header': 'Welcome to the Business B2 Impact -service!',
      'fail-header': 'Oops, there was an error!',
      'fail-desc': 'The information you have entered has been saved and we will contact you as soon as possible.',
      'success-desc-1': 'You are now registered with the Business B2 Impact service, and your login credentials has been sent to your email:',
      'success-desc-2': 'Please contact us if you have any questions about the service. We will be happy to help.',
      'businessb2impactLink': 'Click here to move to the Business B2 Impact -service'
    },
    summary: 'Summary of information entered',
    navigation: {
      desc: 'The menu above shows how the registration is proceeding. If necessary, you can return to any stage you wish by clicking the menu titles.'
    },
    ytj: {
      header: 'Address information import',
      'text-1': 'With business id',
      'text-2': 'we found',
      question: 'Do you want to save this address information?'
    }
  }
}

export default messages
